import { render, staticRenderFns } from "./AccessTypeBadge.vue?vue&type=template&id=3f629daa&scoped=true&"
import script from "./AccessTypeBadge.vue?vue&type=script&lang=js&"
export * from "./AccessTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f629daa",
  null
  
)

export default component.exports